import { type LayoutBuilderState } from "src/frontend/components/Shared/Layout/types"

export enum PortalMode {
  // We're fetching the portal
  Pending = "Pending",

  // We're provisioning the initial portal and layout
  Bootstrap = "Bootstrap",

  // The portal is ready to use
  Ready = "Ready",
}

export enum InviteClientsModalState {
  Initial = "Initial",
  MyClients = "MyClients",
  InviteClients = "InviteClients",
  SendingInvites = "SendingInvites",
  Done = "Done",
}

export interface PortalState extends LayoutBuilderState {
  portalMode: PortalMode
  layoutLoading: boolean
  showInviteClientsModal: boolean
}

export const PORTAL_CONFIG = {
  maxComponentsPerRow: 4,
  rowWidth: 1106,
}
